








import Vue from 'vue'
import AUTHORIZATION_QUERY from '@/graphql/auth/authorizations.gql'
import { Authorization, Feature, Query } from '@/types/generated/graphql'
import { Authorizations } from '@/packages/authorization'

type Data = {
  authorizations: Array<Authorization>
}

type Methods = {
  allowed: AllowedPredicate
}

export type AllowedPredicate = (feature: Feature | undefined) => boolean

export default Vue.extend<Data, Methods, {}, {}>({
  name: 'XAuthorizations',
  data() {
    return {
      authorizations: [],
    }
  },
  methods: {
    allowed(feature) {
      const authorizations = new Authorizations(this.authorizations)
      return authorizations.allowed(feature)
    },
  },
  apollo: {
    authorizations: {
      query: AUTHORIZATION_QUERY,
      update: ({ authorizations }: Query) => authorizations,
    },
  },
})
